import { Injectable } from "@angular/core";
import * as moment from "moment";

@Injectable()
export class AppUtils {

    public dateFormat(date: string) {
        if (!date) {
            return '';
        }
        return moment.utc(date).local().format('yyyy-MM-DD');
    }

    public getYearFromDate(date: string) {
        if (!date) {
            return '';
        }
        return moment.utc(date).local().format('yyyy');
    }
}